import {
	AI_CREDITS_PER_USER_INTERACTION,
	AI_CREDITS_PER_AUTOMATION,
	OfferingAllowances,
	Sku,
} from './data';

export interface CalculateAllowancesArgs {
	allowanceConfigs: OfferingAllowances;
	inputs: {
		offeringSkus: Sku[];
		orgChangePercent: number;
		orgUserCount: number;
		chatAdoptionPercent: number;
		chatUsersPerRulePerMonth: number;
		automationActiveRules: number;
		automationRunsPerRulePerMonth: number;
	};
}

export interface Allowances {
	aiCredits: number;
}

export function calculateAllowances(args: CalculateAllowancesArgs): Allowances {
	const { allowanceConfigs, inputs } = args;
	const { offeringSkus, orgChangePercent, orgUserCount } = inputs;

	let aiCreditsSum = 0;
	let indexedObjectsSum = 0;

	for (const sku of offeringSkus) {
		const config = allowanceConfigs[sku];
		if (!config) {
			continue;
		}
		aiCreditsSum += config.aiCredit.monthly * orgUserCount;
		indexedObjectsSum += config.indexedDocument.monthly * orgUserCount;
	}

	return {
		aiCredits: Math.round(aiCreditsSum * orgChangePercent),
	};
}

export interface CalculateUsageArgs {
	orgUserCount: number;
	orgChangePercent: number;
	chatAdoptionPercent: number;
	chatUsersPerRulePerMonth: number;
	automationActiveRules: number;
	automationRunsPerRulePerMonth: number;
}

export interface Usage {
	aiCredits: number;
}

export function calculateUsage(args: CalculateUsageArgs): Usage {
	const {
		orgUserCount,
		orgChangePercent,
		chatAdoptionPercent,
		chatUsersPerRulePerMonth,
		automationActiveRules,
		automationRunsPerRulePerMonth,
	} = args;

	const userInteractionCredits =
		orgUserCount *
		orgChangePercent *
		chatAdoptionPercent *
		chatUsersPerRulePerMonth *
		AI_CREDITS_PER_USER_INTERACTION;

	const automationCredits =
		automationActiveRules * automationRunsPerRulePerMonth * AI_CREDITS_PER_AUTOMATION;

	return {
		aiCredits: Math.round(userInteractionCredits + automationCredits),
	};
}
